import $ from "jquery";

if (document.querySelector(".master-head")) {

    const masterHeadSliders = document.querySelectorAll(".master-head__slider");
    const masterHeadDots = document.querySelectorAll(".master-head__slide-dots li");

    masterHeadSliders.forEach(masterHeadSlider => {
        $(masterHeadSlider).slick({
            arrows: false,
            dots: false,
            autoplay:true,
            autoplaySpeed: 4000,
            pauseOnHover:true
        });
    });

    masterHeadDots.forEach(masterHeadDot => {
        const slider = masterHeadDot.closest(".master-head__slider");
        masterHeadDot.onclick = () => {
            
            $(slider).slick("slickGoTo", Number(masterHeadDot.dataset.slide));
            
            const activeDots = document.querySelectorAll(`.master-head__slide-dots li[data-slide='${Number(masterHeadDot.dataset.slide)}']`);
            
            masterHeadDots.forEach(masterHeadDot => {
                masterHeadDot.classList.remove("active-slide")
            });

            activeDots.forEach(activeDot => {
                activeDot.classList.add("active-slide");
            });
        }
    });

}